import "./PrivacyTerms.css";
import { useTranslation } from "react-i18next";

const Privacy = () => {
  const { t } = useTranslation();

  return (
    <div>
      <div className="privacy" dir={localStorage.getItem("i18nextLng") === "ar" ? "rtl" : "ltr"}>
        <header>
          <h1>{t("privacy_title")}</h1>
          <p>
            <strong>{t("privacy_effective_date")}</strong>
          </p>
        </header>

        <main>
          <section>
            <h2>{t("privacy_introduction_title")}</h2>
            <p>{t("privacy_introduction_text")}</p>
          </section>

          <section>
            <h2>{t("privacy_info_collect_title")}</h2>
            <p>{t("privacy_info_collect_text")}</p>

            <article>
              <h3>{t("privacy_personal_info_title")}</h3>
              <p>{t("privacy_personal_info_text")}</p>
            </article>

            <article>
              <h3>{t("privacy_usage_data_title")}</h3>
              <p>{t("privacy_usage_data_text")}</p>
            </article>

            <article>
              <h3>{t("privacy_device_info_title")}</h3>
              <p>{t("privacy_device_info_text")}</p>
            </article>
          </section>

          <section>
            <h2>{t("privacy_how_use_title")}</h2>
            <p>{t("privacy_how_use_text")}</p>
            <ul>
              <li>{t("privacy_how_use_item1")}</li>
              <li>{t("privacy_how_use_item2")}</li>
              <li>{t("privacy_how_use_item3")}</li>
              <li>{t("privacy_how_use_item4")}</li>
              <li>{t("privacy_how_use_item5")}</li>
              <li>{t("privacy_how_use_item6")}</li>
            </ul>
          </section>

          <section>
            <h2>{t("privacy_sharing_title")}</h2>
            <p>{t("privacy_sharing_text1")}</p>
            <p>{t("privacy_sharing_text2")}</p>
          </section>

          <section>
            <h2>{t("privacy_security_title")}</h2>
            <p>{t("privacy_security_text")}</p>
          </section>

          <section>
            <h2>{t("privacy_choices_title")}</h2>
            <p>{t("privacy_choices_text")}</p>
            <ul>
              <li>{t("privacy_choices_item1")}</li>
              <li>{t("privacy_choices_item2")}</li>
              <li>{t("privacy_choices_item3")}</li>
            </ul>
          </section>

          <section>
            <h2>{t("privacy_children_title")}</h2>
            <p>{t("privacy_children_text")}</p>
          </section>

          <section>
            <h2>{t("privacy_changes_title")}</h2>
            <p>{t("privacy_changes_text")}</p>
          </section>
        </main>
      </div>
    </div>
  );
};

export default Privacy;
